import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { PostingType } from '../../../lookups/posting-type.model';
import * as PostingTypeActions from './account-posting-type.actions';

export const accountPostingTypesFeatureKey = 'accountPostingTypes';

export interface State extends EntityState<PostingType> {
    // additional entities state properties
}

export const adapter: EntityAdapter<PostingType> =
    createEntityAdapter<PostingType>({
        selectId: (model: PostingType) => model.PostingType
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const PostingTypeReducer = createReducer(
    initialState,
    on(PostingTypeActions.addAccountPostingType, (state, action) =>
        adapter.addOne(action.AccountPostingType, state)
    ),
    on(PostingTypeActions.upsertAccountPostingType, (state, action) =>
        adapter.upsertOne(action.AccountPostingType, state)
    ),
    on(PostingTypeActions.addAccountPostingTypes, (state, action) =>
        adapter.addMany(action.AccountPostingTypes, state)
    ),
    on(PostingTypeActions.upsertAccountPostingTypes, (state, action) =>
        adapter.upsertMany(action.AccountPostingTypes, state)
    ),
    on(PostingTypeActions.updateAccountPostingType, (state, action) =>
        adapter.updateOne(action.AccountPostingType, state)
    ),
    on(PostingTypeActions.updateAccountPostingTypes, (state, action) =>
        adapter.updateMany(action.AccountPostingTypes, state)
    ),
    on(PostingTypeActions.deleteAccountPostingType, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(PostingTypeActions.deleteAccountPostingTypes, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(PostingTypeActions.loadAccountPostingTypes, (state, action) =>
        adapter.setAll(action.AccountPostingTypes, state)
    ),
    on(PostingTypeActions.clearAccountPostingTypes, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return PostingTypeReducer(state, action);
}
